<template>
<div class="slide slide04">
	<h3 class="title">
		성과 중심의 사용자 경험 디자인을 제안합니다 <br> Performance-based Experience Design
	</h3>
	<span class="text">
		성공적인 퍼포먼스 마케팅을 통한 목표 달성을 위해 <br>
		크리에이티브에 녹여낼 핵심 요소를 바탕으로 성과 중심의 사용자 경험 디자인을 제안합니다.
	</span>

	<div class="featureList" v-if="$device.windows">
		<ul class="list">
			<li class="no1">
				<img src="@/assets/images/featureSlide04Img_01.png" alt="">
				<div class="tit">
					Performance<br> 성과
				</div>
				<div class="txt">
					목표의 각 단계를 지속적으로 살피고<br> 장기적으로 최대의 효율을<br> 이끌어 낼 수 있는 요소
				</div>
			</li>
			<li class="no2">
				<img src="@/assets/images/featureSlide04Img_02.png" alt="">
				<div class="tit">
					Experience<br> 경험
				</div>
				<div class="txt">
					사용자의 경험을<br> 다양한 방식으로 분석하고<br> 더 좋은 인사이트를 뽑아낼 수 있는 요소
				</div>
			</li>
			<li class="no3">
				<img src="@/assets/images/featureSlide04Img_03.png" alt="">
				<div class="tit">
					Design<br> 디자인
				</div>
				<div class="txt">
					트렌드를 반영하여<br> 브랜드의 가치를 담은<br> 차별화된 디자인 요소
				</div>
			</li>
		</ul>
	</div>
	<div class="serviceImg" v-else>
		<img src="@/assets/images/featureSlideMo03.png" alt="">
	</div>
	<div class="btnsWrap">
		<a herf="javascript:;" @click="fnSlickNext" class="slideNextBtn" v-if="!$device.windows">다음 페이지</a>
	</div>
</div>
</template>
<script>
export default {
	methods:{
		fnPopClose(){
			this.$emit('popClose' , event)
		},
		fnSlickNext(){
			this.$emit('slick_next' , event)
		}
	}
}
</script>